module.exports = __webpack_public_path__ + "static/developer-bb1a1600117aa807c8934cdcc9904b06.svg";